import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExternalFormsEditor.html?raw';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import { ExternalFormConfig, ExternalFormResult } from "../ExternalFormsTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import lang from 'dojo/_base/lang';
import ExternalFormResultsEditor from '../ExternalFormResultsEditor/ExternalFormResultsEditor';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';


class ExternalFormsEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private resultTable: MdsLax<InstanceType<typeof StaticTable>>;
    private resultStore: MdsLax<InstanceType<typeof EntityStore<ExternalFormResult>>>;

    private tableContainer: MdsLax<InstanceType<typeof ExpandableSection>>;

    private _rowConfig: StaticTable.RowConfig = {
        attributes: [
            "external_database_id",
            "ModificationDate",
            "ModificationUser"
        ],
        headings: [
            (this as any).translate("General_Label_ExternalDatabaseID"),
            (this as any).translate("General_ModificationDate"),
            (this as any).translate("General_ModificationUser"),
        ],
        colNamesInternal: [
            "external_database_id",
            "ModificationDate",
            "ModificationUser",
        ],
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<ExternalFormResult>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.tableCellNode;

        return false;
    }

    private _tableLayout: StaticTable.Layout = {
        label: "resultTable",
        name: "resultTable",
        rows: [(this as any)._rowConfig],
    }

    private setupTable(): void {
        this.resultTable = new StaticTable();
        this.resultTable.setLayout(this._tableLayout);
        this.resultTable.setupFromStore(this.resultStore);
        this.resultTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.resultTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.resultTable.addDefaultRowActionButton("view", lang.hitch(this, this._onClickView));
        //this.resultTable.addCustomRowActionButton("open", lang.hitch(this, this._onClickOpenButton), "fas fa-external-link-alt", this.translate("General_Label_Open"));
        this.resultTable.setCyAttribute("ExternalFormsEditorResultTable");
        this.resultTable.placeAt(this.tableContainer);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let results = this.getAttributeValue("EL_external_form_result_external_form_config");
        this.tableContainer.setMarking(results.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.resultStore.setup(results);
    }

    private _onClickRow(row: StaticTable.StaticTableRow<ExternalFormResult>) {
        let entity = row.rowGroup.entity;
        this._showEntityView(entity);
    }

    private _onClickView(rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResult>) {
        let entity = rowGroup.entity;
        this._showEntityView(entity);
    }

    private _showEntityView(entity: ExternalFormResult) {
        let view = new GenericEntityView();
        view.setup(entity.ID, entity.Classname, entity.ModificationDate + " - " + this.getAttributeValue("description"), "$Displayname");
    }

    private _onClickOpenButton(rowGroup: StaticTable.StaticTableRowGroup<ExternalFormResult>) {
        let entity = rowGroup.entity;
        this._openEditor(entity);
    }

    private _openEditor(entity: ExternalFormResult) {
        let refEntity = this.getAttributeValue("ref_entity_1");
        let editor = new ExternalFormResultsEditor();
        editor.setup(entity.ID, entity.Classname, refEntity);
    }

    setup(entity: ExternalFormConfig) {
        this.setData(entity);
        this.show("dlg", entity.description);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.resultStore = new EntityStore();
        this.setupTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ExternalFormsEditor);